
import { Component, Vue } from 'vue-property-decorator';
import { APP_NAME } from '@/plugins/config';

@Component({})
export default class OnboardingTabStart extends Vue {
    private APP_NAME = APP_NAME;
}
